import React, { useEffect } from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import {
  doiTuongOptions,
  gioiTinhOptions,
  loaiKCBOptions,
  nguonBNOptions,
  quanHeThanNhanOptions,
} from "assets/constants/select-catagory-options";
import { Button, Popconfirm, message } from "antd";
import {
  CancelIconSVG,
  PlusWhiteSVG,
  PrintColorWhiteSVG,
  SaveWhiteIconSVG,
} from "assets";
import Icons from "assets/icons";
import dayjs from "dayjs";
import {
  convertIosStringToDate,
  convertIosStringToDateDayjs,
} from "helper/common";
import { useAppSelector } from "redux/hooks";
import moment from "moment";

interface InsuranceDataType {
  coTheBhyt: boolean | null;
  maTheBhyt: string | null;
  hoTenTrenThe: string | null;
  ngaySinhTrenThe: string | null;
  the5Nam: string | null;
  diaChiTrenThe: string | null;
  ngayBatDau: string | null;
  ngayKetThuc: string | null;
  noiDkkcbd: string | null;
  maNoiDkkcbbd: string | null;
  chucVu: string | null;
  donVi: string | null;
  nguoiCapNhatThe: string | null;
  ngayCapNhatThe: string | null;
  trangThaiBH: number | null;
  phanTramMienGiam: number | null;
}

const { INPUT, SELECT, DATE, CHECKBOX } = FIELD_TYPE;

const receiveSetFieldsValue = (form, dataPassing) => {
  form.setFieldsValue({
    ...dataPassing,
    tinh: dataPassing.tinh,
    huyen: dataPassing.huyen,
    xa: dataPassing.xa,
    tinhThanNhan: dataPassing.tinhThanNhan,
    huyenThanNhan: dataPassing.huyenThanNhan,
    xaThanNhan: dataPassing.xaThanNhan,
    ngaySinh: dataPassing.ngaySinh ? dayjs(dataPassing.ngaySinh) : null,
    ngayCap: dataPassing.ngayCap ? dayjs(dataPassing.ngayCap) : null,
    thoiGianNhapVienNoiTru: dataPassing?.thoiGianNhapVienNoiTru
      ? dayjs(dataPassing?.thoiGianNhapVienNoiTru)
      : null,
    ngaySinhThanNhan: dataPassing.ngaySinhThanNhan
      ? dayjs(dataPassing.ngaySinhThanNhan)
      : null,
    ngaySinhTrenThe: dataPassing.ngaySinhTrenThe
      ? convertIosStringToDateDayjs(dataPassing.ngaySinhTrenThe)
      : null,
    the5Nam: dataPassing.the5Nam ? dayjs(dataPassing.the5Nam) : null,
    ngayBatDau: dataPassing.ngayBatDau ? dayjs(dataPassing.ngayBatDau) : null,
    ngayKetThuc: dataPassing.ngayKetThuc
      ? dayjs(dataPassing.ngayKetThuc)
      : null,
    ngayCapNhatThe: dataPassing.ngayCapNhatThe
      ? dayjs(dataPassing.ngayCapNhatThe)
      : null,
    ngayNhapVien: dataPassing.ngayNhapVien
      ? dayjs(dataPassing.ngayNhapVien)
      : null,
    ngayTao: dataPassing.ngayTao ? dayjs(dataPassing.ngayTao) : null,
    thoiGianTraThe: convertIosStringToDate(dataPassing?.thoiGianTraThe),
  });
};

const CancelBtn = (handleFunc) => {
  return (
    <Popconfirm title="Xác nhận huỷ khám?" onConfirm={handleFunc}>
      <Button
        className="btn-cancel custom-btn"
        type="text"
        icon={<Icons.close />}
      >
        Hủy khám
      </Button>
    </Popconfirm>
  );
};
const NewPatientBtn = (handleFunc) => {
  return (
    <Button
      className="btn-sub"
      type="text"
      icon={<PlusWhiteSVG />}
      onClick={handleFunc}
    >
      Bệnh nhân mới
    </Button>
  );
};
const NewMedicalBillBtn = (handleFunc) => {
  return (
    <Button
      className="btn-sub"
      type="text"
      icon={<PlusWhiteSVG />}
      onClick={handleFunc}
    >
      Phiếu khám mới
    </Button>
  );
};
const SavePrintBtn = (handleFunc, data) => {
  return (
    <Button
      className="btn-sub"
      type="text"
      icon={<PrintColorWhiteSVG />}
      onClick={(e) => handleFunc(data)}
    >
      Lưu và In
    </Button>
  );
};

const CompleteBtn = (handleFunc, loading) => {
  return (
    <Button
      className="btn-sub"
      type="text"
      onClick={handleFunc}
      loading={loading}
    >
      Hoàn thành khai báo
    </Button>
  );
};
const PayBtn = (handleFunc, loading) => {
  // const loadingPay = useAppSelector(state => state.receive.loadingPay);
  return (
    <Button
      className="btn-sub"
      type="text"
      onClick={handleFunc}
      loading={loading}
    >
      Thanh toán
    </Button>
  );
};

const CompleteKCBBtn = (handleFunc, data) => {
  return (
    <Button className="btn-sub" type="text" onClick={(e) => handleFunc(data)}>
      Hoàn thành KCB
    </Button>
  );
};
const SaveBtn = (handleFunc, data) => {
  return (
    <Button
      className="custom-btn"
      type="primary"
      onClick={(e) => handleFunc(data)}
      icon={<SaveWhiteIconSVG />}
    >
      Lưu lại
    </Button>
  );
};

const mainInfoFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã khám bệnh",
    name: "id",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy nhập mã khám bệnh" }],
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "idBenhNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy nhập mã bệnh nhân" }],
  },
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTen",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy nhập họ tên bệnh nhân" }],
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinh",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy chọn ngày sinh cho bệnh nhân" }],
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinh",
    options: gioiTinhOptions,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Di động",
    name: "dienThoai",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Tỉnh",
    name: "tinh",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Huyện",
    name: "huyen",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Xã",
    name: "xa",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChi",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
];

const expandInfoFields: DataFormField[] = [
  {
    type: SELECT,
    label: "Quốc tịch",
    name: "quocTich",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Tôn giáo",
    name: "tonGiao",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Dân tộc",
    name: "danToc",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Nghề",
    name: "ngheNghiep",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Nơi làm việc",
    name: "noiLamViec",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Số CMND",
    name: "soCmnd",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: DATE,
    label: "Ngày cấp",
    name: "ngayCap",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Nơi cấp",
    placeholder: "Nhập",
    name: "noiCap",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
];

const relativeInfoFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Họ tên",
    name: "hoTenThanNhan",
    placeholder: "Nhập",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: DATE,
    label: "Ngày sinh",
    name: "ngaySinhThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioiTinhThanNhan",
    placeholder: "Chọn",
    options: gioiTinhOptions,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dienThoaiThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Tỉnh",
    // name: "tinhThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Huyện",
    // name: "huyenThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Xã",
    // name: "xaThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    placeholder: "Nhập",
    name: "diaChiThanNhan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Quan hệ với BN",
    name: "quanHeThanNhan",
    options: quanHeThanNhanOptions,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
];

const receiveInfoFields: DataFormField[] = [
  {
    type: DATE,
    label: "Ngày nhập viện",
    placeholder: "DD/MM/YYYY",
    name: "ngayNhapVien",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Chọn ngày nhập viện" }],
  },
  {
    type: SELECT,
    label: "Loại KCB",
    name: "loạiKcb",
    options: loaiKCBOptions,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy chọn loại khám chữa bệnh" }],
  },
  {
    type: SELECT,
    label: "Đối tượng",
    name: "doiTuong",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: SELECT,
    label: "Nguồn BN",
    name: "nguonBn",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Từ viện",
    name: "tuVien",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Tai nạn",
    name: "taiNan",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Nơi làm",
    name: "noiLam",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
];

const registerInfoFields: DataFormField[] = [
  {
    type: SELECT,
    label: "Dịch vụ",
    name: "dichVu",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    rules: [{ required: true, message: "Hãy chọn dịch vụ" }],
  },
  {
    type: INPUT,
    label: "Lý do khám",
    name: "lyDoKham",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
  {
    type: INPUT,
    label: "Lý do khác",
    name: "lyDoKhac",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
  },
];

const toOptions = (vs: any[]) => {
  return vs.map((v) => {
    return { value: v.id, label: v.name };
  });
};
const toOptions2 = (vs: any[]) => {
  return vs.map((v) => {
    return { value: v.id, label: v.tenDichVu };
  });
};
const toRoomOptions = (vs: any[]) => {
  return vs.map((v) => {
    return { value: v.id, label: v.tenPhong };
  });
};

export {
  mainInfoFields,
  expandInfoFields,
  relativeInfoFields,
  receiveInfoFields,
  registerInfoFields,
  receiveSetFieldsValue,
  CancelBtn,
  CompleteBtn,
  PayBtn,
  SavePrintBtn,
  SaveBtn,
  NewPatientBtn,
  NewMedicalBillBtn,
  toOptions,
  toOptions2,
  toRoomOptions,
  InsuranceDataType,
  CompleteKCBBtn,
};
